import * as React from "react";
import { GeoApps, App } from "@mapgear/geoapps-ui-framework";
import { AppLayout } from "./components/AppLayout";

export const Main = () => {

    const geoappsOptions = {
        authorize: "oidc",
        authorizationMode: "silent",
        allowAnonymous: true
    };

    if (((window as any)._editMode)) {
        geoappsOptions.authorizationMode = "silent";
    }

    const appOptions = {
        editor: {
            enabled: true,
            app: {
                options: {
                    public: {
                        show: true,
                        value: true,
                    },
                    default: {
                        show: true,
                        value: false,
                    }
                }
            },
            screens: {
                enabled: false
            }
        },
    };

    return (
        <GeoApps {...geoappsOptions}>
            <App {...appOptions}>
                <AppLayout />
            </App>
        </GeoApps>
    )
};
